import { render } from "./pager.vue?vue&type=template&id=3d0ad0b8&scoped=true"
import script from "./pager.vue?vue&type=script&lang=js"
export * from "./pager.vue?vue&type=script&lang=js"

import "./pager.vue?vue&type=style&index=0&id=3d0ad0b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d0ad0b8"

export default script